(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-picker-item/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/race-picker-item/assets/javascripts/prescript.js');

'use strict';

svs.racing = svs.racing || {};


 })(window);